import { Component, inject, Input, OnInit, signal, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Record } from 'src/app/models/record';
import { OtkList } from 'src/app/models/user-item-list';
import { ApiService } from 'src/app/services/api.service';
import { LocaleService } from 'src/app/services/locale.service';
import { UserService } from 'src/app/services/user.service';
import { Util } from 'src/app/util';
import { SliderComponent } from '../slider/slider.component';
import { SearchState } from 'src/app/models/search-model';
import { Location } from '@angular/common';
import { Collection } from '../../models/collection';
import { ToastService } from '../../_core/services/toast.service';

@Component({
  selector: 'app-slider-list',
  templateUrl: './slider-list.component.html',
  styleUrls: ['./slider-list.component.scss'],
})
export class SliderListComponent implements OnInit {
  private readonly toastService = inject(ToastService);

  readonly showDeleteListDialog = signal<boolean>(false);
  readonly descriptionToDeleteListDialog = signal<string>('');

  @Input()
  collection: Partial<Collection>;

  @Input()
  list: OtkList;

  @Input()
  forListSubscriptions: boolean;

  @ViewChild('slider', { static: false })
  slider: SliderComponent;

  records: Record[] = [];
  loading: boolean;
  showEmptyBoard: boolean;

  constructor(
    private apiService: ApiService,
    private localeService: LocaleService,
    private userService: UserService,
    private router: Router,
    private _location: Location
  ) { }

  ngOnInit() {
    this.loadRecords();
    this.descriptionToDeleteListDialog.set(this.getDeleteListLabel());
  }

  private loadRecords() {
    this.loading = true;
    const recordIds = this.list.items.map((listElement) => listElement.recordId).slice(0, 10);
    if (recordIds.length > 0) {
      this.apiService.getRecords({ recordIds: recordIds }).subscribe((result) => {
        this.records = result.records;
        this.loading = false;
        this.shouldShowEmptyBoard();
      });
    } else {
      this.loading = false;
      this.shouldShowEmptyBoard();
    }
  }

  addTitles() {
    this.router.navigate(['/search', 'lists', this.list.id]);
  }

  shouldShowEmptyBoard() {
    this.showEmptyBoard = this.records.length === 0;
  }

  copyToClipboard() {
    const slug = this.getListSlug();
    const url = new URL(Util.getOrigin() + '/list/' + slug);
    Util.copyToClipboard(url.href);
    this.toastService.showToast('messages.copied', 'info');
  }

  editList() {
    this.userService.editList(this.list);
  }

  deleteList() {
    if (this.list.userId !== this.userService.getUserId()) {
      return;
    }

    this.showDeleteListDialog.set(false);
    this.apiService.deleteList(this.userService.getUserId(), this.list.id).subscribe((deletedList) => {
      this.userService.lists = this.userService.lists.filter((l) => l.id !== deletedList.id);
      this.toastService.showToast('messages.lists.remove');
    });
  }

  showList() {
    let state = {
      prevNav: this._location.path(),
    } as SearchState;
    this.router.navigate(['/list/' + this.getListSlug()], { state });
  }

  getListSlug() {
    return Util.slugify(this.list.name) + '-' + this.list.id;
  }

  unfollowList() {
    this.userService.unfollowList(this.list).subscribe();
  }

  exploreCatalog() {
    this.slider.exploreCatalog();
  }

  private getDeleteListLabel() {
    if (this.list?.followers > 0) {
      return 'user.lists.dialogs.deleteWhenFollowed.body';
    }

    return 'user.lists.dialogs.deleteList.body';
  }
}
